var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.3 41.33",
    height: 56,
    width: 56,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.43,33H5l3.46,5.2V33h2.46v8.38H7.54L3.93,36.1h0v5.23H1.43Z",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.38,33h6.85v2.13H15v1.06h3.68v2H15v3.21H12.38Z",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.07,35.08h1.52c.63,0,1.22.07,1.22.81s-.72.9-1.37.9H23.07v2H25c1.93,0,3.3-1,3.3-3A2.86,2.86,0,0,0,25.19,33H20.48v8.38h2.59Z",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3,41.33H26.68L31.33,33h2.74l4.64,8.38H36.1l-1-1.67H30.21l1.05-1.85h2.9L32.7,35.24Z",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39,32.18a2,2,0,0,1,0,4,2,2,0,1,1,0-4V31.9a2.31,2.31,0,1,0,2.3,2.29A2.29,2.29,0,0,0,39,31.9Z",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.43,33.13h.75c.31,0,.69.07.69.44,0,.52-.56.46-.94.46h-.5v.25H39l.74,1.21h.38l-.78-1.21c.47,0,.81-.19.81-.71A.65.65,0,0,0,39.9,33a1.12,1.12,0,0,0-.62-.12H38.15v2.56h.32V33.13Z",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.34,26.33h3.92a1.81,1.81,0,0,0,1.81-1.8V7a1.8,1.8,0,0,0-1.81-1.79H7A1.8,1.8,0,0,0,5.21,7V24.53A1.81,1.81,0,0,0,7,26.33h3.93v5.16H4.64A4.64,4.64,0,0,1,0,26.89V4.61A4.64,4.64,0,0,1,4.64,0h29a4.64,4.64,0,0,1,4.65,4.61V26.89a4.64,4.64,0,0,1-4.65,4.6H27.34Z",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.47,27.72a7.82,7.82,0,0,1-1.84-5.29c.12-3.22,1.18-3.4,1.43-5.79s-.5-3.4-.5-3.4a28.88,28.88,0,0,1,3.87,6.1,3.35,3.35,0,0,0,.46-2.85c-.37-1.92-1.18-2.72-.46-5.6a10.42,10.42,0,0,0,1.31,3.47,24.19,24.19,0,0,1,3.61,5.78,5.81,5.81,0,0,0,1.34-2.85,17.86,17.86,0,0,0,.1-4.67s3.11,4.55,3.3,7.89S24,27.29,24,27.29a7.34,7.34,0,0,0,.19-3.47,12.37,12.37,0,0,1-4.64,7.64,12.83,12.83,0,0,0,.59-5c-.16-3-.84-3.55-.84-3.55a57,57,0,0,1-2.12,7.64,6.9,6.9,0,0,1-2.09-2.66c-.47-1.43-1-3.87-1-3.87a4.15,4.15,0,0,0-.65,1.67A17.54,17.54,0,0,0,13.47,27.72Z",
    fill: "#ed1944"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.26,17a7,7,0,0,0-.34-4.42c-1-2.35-2.12-1.73-2.75-6.16,0,0-1.71,3.62,0,6C19.61,14.36,21.26,17,21.26,17Z",
    fill: "#ed1944"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColor);
export default __webpack_public_path__ + "static/media/logo-color.76a28487e54352516fcaafd0fbc2b2d2.svg";
export { ForwardRef as ReactComponent };